<template>
    <span
        :class="disabled ? 'module-disabled-struct' : ''"
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t('swifter')})
                : ''
        ">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <div v-if="computedList.length === 0">
                {{ $t('none.x', {x: $t('files')}) }}
            </div>
            <div v-else class="uk-overflow-auto">
                <table
                    class="uk-table uk-table-middle uk-table-divider uk-table-hover">
                    <thead>
                        <tr class="uk-text-nowrap">
                            <th class="uk-table-shrink">
                                {{ $t('name') }}
                            </th>

                            <th class="uk-table-shrink">
                                {{ $t('deleted') }}
                            </th>

                            <th class="uk-table-shrink">
                                {{ $t('size') }}
                            </th>

                            <th class="uk-table-shrink">
                                {{ $t('created') }}
                            </th>

                            <th class="uk-table-shrink" />
                            <th class="uk-table-shrink" />
                            <th class="uk-table-shrink" />
                            <th class="uk-table-shrink" />

                            <th class="uk-table-shrink">
                                {{ $t('sent.to') }}
                            </th>

                            <th class="uk-table-shrink">
                                {{ $t('message') }}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            v-for="(transfer, key) in computedList"
                            :key="'transfer-archive-' + key"
                            class="uk-text-nowrap">
                            <td>
                                <Icon
                                    class="uk-margin-small-right-x"
                                    icon="tag" />
                                {{ transfer.name }}
                            </td>

                            <td>
                                <Icon
                                    class="uk-margin-small-right-x"
                                    icon="trash" />
                                <span
                                    :uk-tooltip="
                                        'title:' +
                                        getFormattedDateTimeByDateString(
                                            transfer.deletedAt
                                        )
                                    ">
                                    {{
                                        getFormattedDateByDateString(
                                            transfer.deletedAt
                                        )
                                    }}
                                </span>
                            </td>

                            <td>
                                <Icon
                                    class="uk-margin-small-right-x"
                                    icon="database" />
                                <span v-if="transfer.sizeInBytes">
                                    {{ getParsedBytes(transfer.sizeInBytes) }}
                                </span>
                                <Icon v-else icon="minus" />
                            </td>

                            <td>
                                <Icon
                                    class="uk-margin-small-right-x"
                                    icon="clock" />
                                <span
                                    :uk-tooltip="
                                        'title:' +
                                        getFormattedDateTimeByDateString(
                                            transfer.createdAt
                                        )
                                    ">
                                    {{
                                        getFormattedDateByDateString(
                                            transfer.createdAt
                                        )
                                    }}
                                </span>
                            </td>

                            <td>
                                <span
                                    class="uk-margin-small-right-x"
                                    :uk-tooltip="$t('transfer.clicked')">
                                    <Icon icon="folder-open" />
                                    {{ transfer.stats.clicked }}
                                </span>
                            </td>

                            <td>
                                <span
                                    class="uk-margin-small-right-x"
                                    :uk-tooltip="
                                        $t('transfer.download.clicked')
                                    ">
                                    <Icon icon="pull" />
                                    {{ transfer.stats.downloadClicked }}
                                </span>
                            </td>

                            <td>
                                <span
                                    class="uk-margin-small-right-x"
                                    :uk-tooltip="
                                        $t('transfer.download.completed')
                                    ">
                                    <Icon icon="cloud-download" />
                                    {{ transfer.stats.downloadCompleted }}
                                </span>
                            </td>

                            <td>
                                <span
                                    :uk-tooltip="
                                        $t('transfer.session.duration')
                                    ">
                                    <Icon icon="eye" />
                                    {{
                                        pretty(transfer.stats.viewDuration, 's')
                                    }}
                                </span>
                            </td>

                            <td class="uk-text-center">
                                <span
                                    v-if="transfer.email"
                                    :uk-tooltip="'title:' + transfer.email">
                                    <Icon icon="mail" />
                                </span>
                                <Icon v-else icon="minus" />
                            </td>

                            <td class="uk-text-center">
                                <span
                                    v-if="transfer.message"
                                    :uk-tooltip="'title:' + transfer.message">
                                    <Icon icon="comment" />
                                </span>
                                <Icon v-else icon="minus" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </span>
    </span>
</template>

<script>
import Icon from '@/components/generic/Icon.vue';
import pretty from 'pretty-time';

export default {
    name: 'TransfersArchiveForm',
    components: {Icon},
    props: {
        disabled: Boolean,
        settings: Object,
    },
    computed: {
        computedList() {
            if (!this.settings.transfers) {
                return [];
            }

            return this.settings.transfers.filter(
                (transfer) => transfer.deletedAt
            );
        },
    },
    methods: {
        pretty,
    },
};
</script>

<style lang="scss" scoped></style>
